/* eslint-disable @typescript-eslint/naming-convention */
export const PURGE_MENU = "@MENU/PURGE_MENU";
export type PURGE_MENU = typeof PURGE_MENU;

export const SET_GLOBAL_USER = "@GLOBAL/SET_GLOBAL_USER";
export type SET_GLOBAL_USER = typeof SET_GLOBAL_USER;

export const SET_GLOBAL_ROLE = "@GLOBAL/SET_GLOBAL_ROLE";
export type SET_GLOBAL_ROLE = typeof SET_GLOBAL_ROLE;

export const SET_GLOBAL_USER_STATUS = "@GLOBAL/SET_GLOBAL_USER_STATUS";
export type SET_GLOBAL_USER_STATUS = typeof SET_GLOBAL_USER_STATUS;

export const SET_GLOBAL_USER_NAME = "@GLOBAL/SET_GLOBAL_USER_NAME";
export type SET_GLOBAL_USER_NAME = typeof SET_GLOBAL_USER_NAME;

export const SET_GLOBAL_ERROR = "@GLOBAL/SET_GLOBAL_ERROR";
export type SET_GLOBAL_ERROR = typeof SET_GLOBAL_ERROR;

export const SET_GLOBAL_MODAL = "@GLOBAL/SET_GLOBAL_MODAL";
export type SET_GLOBAL_MODAL = typeof SET_GLOBAL_MODAL;

export const SET_APP_SETTINGS = "@GLOBAL/SET_APP_SETTINGS";
export type SET_APP_SETTINGS = typeof SET_APP_SETTINGS;

export const PURGE_USER_ROLE = "@GLOBAL/PURGE_USER_ROLE";
export type PURGE_USER_ROLE = typeof PURGE_USER_ROLE;

export const ADD_LOCATION = "@GLOBAL/ADD_LOCATION";
export type ADD_LOCATION = typeof ADD_LOCATION;

export const SET_SURVEY_TRACKING = "@GLOBAL/SET_SURVEY_TRACKING";
export type SET_SURVEY_TRACKING = typeof SET_SURVEY_TRACKING;

export const SHOW_JOB_QUEUE = "@GLOBAL/SHOW_JOB_QUEUE";
export type SHOW_JOB_QUEUE = typeof SHOW_JOB_QUEUE;

export const MASQUERADE_MODE = "@GLOBAL/MASQUERADE_MODE";
export type MASQUERADE_MODE = typeof MASQUERADE_MODE;

export const ADD_LATEST_PACK_SIZE = "@GLOBAL/ADD_LATEST_PACK_SIZE";
export type ADD_LATEST_PACK_SIZE = typeof ADD_LATEST_PACK_SIZE;
